
import { get, post, patch } from "@/lib/fetcher";

/**
 * Fetch all Venues
 */
export async function getClients() {
    return await get("/admin/clients");
}

export async function getClient(id) {
    return await get(`/admin/clients/${id}`);
}

/**
 * Create a new skill
 * @param {Object} data - { category, skill, starting_price, top_price, price_unit }
 */
export async function postClient(data) {
    return await post("/admin/clients", data);
}

export async function enableClientLogin(id){
    return await patch(`/admin/clients/${id}/enable_login`)
}

export async function disableClientLogin(id){
    return await patch(`/admin/clients/${id}/disable_login`)
}

export async function setClientAsSigner(id){
    return await patch(`/admin/clients/${id}/set_as_signer`)
}

export async function unsetClientAsSigner(id){
    return await patch(`/admin/clients/${id}/unset_as_signer`)
}

/**
 * Update an existing skill by ID
 * @param {string|number} id - the skill ID
 * @param {Object} data - updated skill data
 */
export async function patchClient(id, data) {
    return await patch("/admin/clients", id, data);
}
